import { useEffect } from 'react';

export const useDebouncedEffect = (fn: () => void | string, rerun: any[] = [], ms: number = 500) => {
  useEffect(() => {
    const timeout = setTimeout(fn, ms);
    return () => clearTimeout(timeout);
  }, rerun);
};
